import { render, staticRenderFns } from "./SalarySampleBriefDialog.vue?vue&type=template&id=9438a49e&scoped=true"
import script from "./SalarySampleBriefDialog.vue?vue&type=script&lang=js"
export * from "./SalarySampleBriefDialog.vue?vue&type=script&lang=js"
import style0 from "./SalarySampleBriefDialog.vue?vue&type=style&index=0&id=9438a49e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9438a49e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9438a49e')) {
      api.createRecord('9438a49e', component.options)
    } else {
      api.reload('9438a49e', component.options)
    }
    module.hot.accept("./SalarySampleBriefDialog.vue?vue&type=template&id=9438a49e&scoped=true", function () {
      api.rerender('9438a49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalarySampleBriefDialog.vue"
export default component.exports